export const REQUEST_UPDATE_PROFILE_DATA = "request_update_profile_data"
export const UPDATE_PROFILE_DATA_SUCCESS = "update_profile_data_success"
export const UPDATE_PROFILE_DATA_FAILURE = "update_profile_data_failure"

export const CLEAR_UPDATE_PROFILE_STATES = "clear_update_profile_states"
